import { type UseQueryResult } from '@tanstack/react-query';
import { z } from 'zod';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { queryKeys } from '../../../lib/api/query-keys.js';

import {
  promotionDetail,
  promotionRow,
  type PromotionDetail,
  type PromotionRow,
} from './schemas.js';
import { promotionEndpoints } from './endpoints.js';

const promotionList = z.array(promotionRow);

/** All promotions for the current tenant. */
export function usePromotions(): UseQueryResult<readonly PromotionRow[]> {
  return useApiQuery<typeof promotionList>({
    queryKey: queryKeys.promotions.list({}),
    path: promotionEndpoints.list,
    schema: promotionList,
  });
}

/** One promotion by id. */
export function usePromotion(promotionId: string): UseQueryResult<PromotionDetail> {
  return useApiQuery<typeof promotionDetail>({
    queryKey: queryKeys.promotions.detail(promotionId),
    path: promotionEndpoints.detail(promotionId),
    schema: promotionDetail,
    enabled: promotionId !== '',
  });
}
